/* bs24-zoom.js – Runde 7 (01.10.2026)
 * Eigene kleine Datei, Hersteller-JS (global.js, main-product.liquid, Swiper) bleibt unveraendert.
 *
 * 1) Grossansicht am PC (Maus/Trackpad): stufenloser Zoom
 *    - Mausrad bzw. Trackpad-Pinch zoomt um den Mauszeiger, Schaltflaechen + und -
 *    - Ziehen verschiebt das vergroesserte Bild, Doppelklick setzt zurueck
 *    - Swiper 8.4.3 kann Zoom nur stufig (Doppelklick = maxRatio, Pinch nur Touch) und kein Mausrad;
 *      deshalb wird am PC dessen Zoom-Modul fuer die offene Grossansicht abgeschaltet und hier ersetzt.
 *      Am Handy bleibt Swiper-Zoom (Pinch, Doppeltipp) unveraendert.
 * 2) Handy-Wisch-Fehler: Beim Schliessen der Grossansicht gibt ModalDialog.hide() den Fokus an den
 *    Oeffner-Button (.product__media-toggle) in der Galerie zurueck. Swiper 8 verwirft jede Wischbewegung,
 *    deren Ziel das fokussierte Element ist und auf 'button' passt (focusableElements) -> Galerie
 *    laesst sich bis zum Neuladen nicht mehr wischen. Loesung: nach dem Schliessen per Finger/Maus
 *    diesen Fokus loesen (Tastaturbedienung behaelt den Fokus).
 *    Zusaetzlich: Kommt die Seite aus dem Zurueck-Cache mit offener Grossansicht, wird sie geschlossen.
 * 4) R7b: Beim Oeffnen/Folienwechsel wird eine hoeher aufgeloeste Bildvariante (width=2048/3000/3840 je
 *    Anzeigebreite x devicePixelRatio x 2,5) vorgeladen und erst nach dem Dekodieren eingesetzt (kein Flackern).
 * 3) Waehrend die Grossansicht offen ist, traegt <body> die Klasse bs24-gross-offen
 *    (CSS blendet damit z. B. den Judge.me-Reiter aus).
 */
(function () {
  'use strict';
  if (window.__bs24Zoom) return;
  window.__bs24Zoom = true;

  var MIN = 1, MAX = 3; // R7c: Hoechstzoom 3x (Bildschaerfe)
  var fein = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var letzteEingabe = 'pointer';
  document.addEventListener('pointerdown', function () { letzteEingabe = 'pointer'; }, true);
  document.addEventListener('keydown', function () { letzteEingabe = 'key'; }, true);

  /* ---------- 2) Fokus nach dem Schliessen loesen ---------- */
  document.body && document.body.addEventListener('modalClosed', fokusLoesen);
  function fokusLoesen() {
    setTimeout(function () {
      var a = document.activeElement;
      if (letzteEingabe === 'pointer' && a && a !== document.body && a.closest &&
          a.closest('.product__media-list, .product__media-sublist, .js-media-list, .js-media-sublist')) {
        a.blur();
      }
    }, 0);
  }
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('product-modal[open]').forEach(function (m) {
      try { m.hide(); } catch (err) { m.removeAttribute('open'); document.body.classList.remove('overflow-hidden'); }
    });
    document.body.classList.remove('bs24-gross-offen');
  });

  /* ---------- 3) + 1) Grossansicht beobachten ---------- */
  function init() {
    document.querySelectorAll('product-modal').forEach(function (modal) {
      if (modal.__bs24) return;
      modal.__bs24 = true;
      new MutationObserver(function () {
        if (modal.hasAttribute('open')) { document.body.classList.add('bs24-gross-offen'); if (fein) setTimeout(function () { aktivieren(modal); }, 60); }
        else { document.body.classList.remove('bs24-gross-offen'); if (fein) deaktivieren(modal); }
      }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  var st = { s: 1, x: 0, y: 0, img: null, swiper: null, ziehen: null };

  function aktivesBild(modal) {
    var sw = st.swiper;
    var slide = sw && sw.slides ? sw.slides[sw.activeIndex] : modal.querySelector('.swiper-slide-active');
    return slide ? slide.querySelector('.swiper-zoom-container > img') : null;
  }
  function anwenden() {
    if (!st.img) return;
    if (st.s <= 1.001) { st.s = 1; st.x = 0; st.y = 0; }
    if (st.s > 1) scharf(st.img);
    begrenzen();
    st.img.style.transform = st.s === 1 ? '' : 'translate3d(' + st.x + 'px,' + st.y + 'px,0) scale(' + st.s + ')';
    st.img.style.transformOrigin = '50% 50%';
    st.img.style.cursor = st.s > 1 ? (st.ziehen ? 'grabbing' : 'grab') : 'zoom-in';
    var modal = st.img.closest('product-modal');
    if (modal) modal.classList.toggle('bs24-gezoomt', st.s > 1);
    if (st.swiper && !st.swiper.destroyed) st.swiper.allowTouchMove = st.s === 1;
    var minus = modal && modal.querySelector('.bs24-zoom__btn--minus');
    if (minus) minus.disabled = st.s === 1;
    var plus = modal && modal.querySelector('.bs24-zoom__btn--plus');
    if (plus) plus.disabled = st.s >= MAX;
  }
  function begrenzen() {
    if (!st.img) return;
    var w = st.img.offsetWidth, h = st.img.offsetHeight;
    var box = st.img.parentElement.getBoundingClientRect();
    var mx = Math.max(0, (w * st.s - box.width) / 2), my = Math.max(0, (h * st.s - box.height) / 2);
    st.x = Math.min(mx, Math.max(-mx, st.x));
    st.y = Math.min(my, Math.max(-my, st.y));
  }
  function zoomUm(faktor, cx, cy) {
    if (!st.img) return;
    var neu = Math.min(MAX, Math.max(MIN, st.s * faktor));
    var r = st.img.parentElement.getBoundingClientRect();
    // Punkt unter dem Zeiger bleibt stehen (Ursprung = Mitte des Containers)
    var px = cx - (r.left + r.width / 2), py = cy - (r.top + r.height / 2);
    var k = neu / st.s;
    st.x = px - (px - st.x) * k;
    st.y = py - (py - st.y) * k;
    st.s = neu;
    anwenden();
  }
  // B1 (R7b): hoeher aufgeloestes Bild nachladen; altes bleibt sichtbar, bis das neue dekodiert ist
  function scharf(img) {
    if (!img || img.__bs24scharf) return;
    var src = img.currentSrc || img.src || '';
    if (!/\/cdn\/shop\//.test(src)) return;
    var breite = img.getBoundingClientRect().width || img.offsetWidth || 1000;
    var dpr = window.devicePixelRatio || 1;
    var ziel = Math.ceil(breite * dpr * 2.5);
    var stufen = [2048, 3000, 3840], w = 3840;
    for (var i = 0; i < stufen.length; i++) { if (stufen[i] >= ziel) { w = stufen[i]; break; } }
    var m = src.match(/[?&]width=(\d+)/);
    if (m && +m[1] >= w) { img.__bs24scharf = true; return; }
    var url = m ? src.replace(/([?&]width=)\d+/, '$1' + w) : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    img.__bs24scharf = true;
    var vor = new Image();
    vor.decoding = 'async';
    vor.onload = function () {
      var fertig = function () { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = url; };
      if (vor.decode) vor.decode().then(fertig, fertig); else fertig();
    };
    vor.onerror = function () { img.__bs24scharf = false; };
    vor.src = url;
  }
  function zuruecksetzen() { st.s = 1; st.x = 0; st.y = 0; anwenden(); }

  function aktivieren(modal) {
    var el = modal.querySelector('#product-page-swiper');
    st.swiper = el && el.swiper ? el.swiper : null;
    if (st.swiper && st.swiper.zoom && st.swiper.zoom.enabled) st.swiper.zoom.disable();
    if (st.swiper && !st.swiper.__bs24) {
      st.swiper.__bs24 = true;
      st.swiper.on('slideChange', function () { if (st.img) { st.img.style.transform = ''; st.img.style.cursor = ''; } st.s = 1; st.x = 0; st.y = 0; st.img = aktivesBild(modal); scharf(st.img); anwenden(); });
    }
    st.img = aktivesBild(modal);
    st.s = 1; st.x = 0; st.y = 0; anwenden();
    scharf(st.img);
    if (!modal.__bs24ui) {
      modal.__bs24ui = true;
      var dlg = modal.querySelector('.product-media-modal__dialog') || modal;
      var lang = (document.documentElement.lang || 'de').slice(0, 2);
      var txt = { de: ['Vergrößern', 'Verkleinern'], en: ['Zoom in', 'Zoom out'], fr: ['Agrandir', 'Réduire'], it: ['Ingrandisci', 'Riduci'], es: ['Ampliar', 'Reducir'], nl: ['Inzoomen', 'Uitzoomen'] }[lang] || ['+', '−'];
      var bar = document.createElement('div');
      bar.className = 'bs24-zoom';
      bar.innerHTML = '<button type="button" class="bs24-zoom__btn bs24-zoom__btn--minus" aria-label="' + txt[1] + '"><svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true"><path d="M4 10h12" stroke="currentColor" stroke-width="1.8" fill="none"/></svg></button>' +
        '<button type="button" class="bs24-zoom__btn bs24-zoom__btn--plus" aria-label="' + txt[0] + '"><svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true"><path d="M4 10h12M10 4v12" stroke="currentColor" stroke-width="1.8" fill="none"/></svg></button>';
      dlg.appendChild(bar);
      bar.querySelector('.bs24-zoom__btn--plus').addEventListener('click', function (e) { e.stopPropagation(); mitte(1.5); });
      bar.querySelector('.bs24-zoom__btn--minus').addEventListener('click', function (e) { e.stopPropagation(); mitte(1 / 1.5); });
      var inhalt = modal.querySelector('.product-media-modal__content') || dlg;
      inhalt.addEventListener('wheel', function (e) {
        if (!modal.hasAttribute('open') || !st.img) return;
        e.preventDefault();
        var d = e.deltaY;
        if (e.deltaMode === 1) d *= 16;
        var f = Math.exp(-d * (e.ctrlKey ? 0.01 : 0.0025));
        zoomUm(f, e.clientX, e.clientY);
      }, { passive: false });
      inhalt.addEventListener('dblclick', function (e) {
        if (!st.img) return;
        e.preventDefault(); e.stopPropagation();
        zuruecksetzen();
      }, true);
      inhalt.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0 || st.s <= 1 || !st.img) return;
        if (!e.target.closest('.swiper-zoom-container')) return;
        e.preventDefault(); e.stopPropagation();
        st.ziehen = { x: e.clientX, y: e.clientY, ox: st.x, oy: st.y, id: e.pointerId };
        try { inhalt.setPointerCapture(e.pointerId); } catch (err) {}
        anwenden();
      }, true);
      inhalt.addEventListener('pointermove', function (e) {
        if (!st.ziehen) return;
        e.preventDefault();
        st.x = st.ziehen.ox + (e.clientX - st.ziehen.x);
        st.y = st.ziehen.oy + (e.clientY - st.ziehen.y);
        anwenden();
      }, true);
      var ende = function () { if (st.ziehen) { st.ziehen = null; anwenden(); } };
      inhalt.addEventListener('pointerup', ende, true);
      inhalt.addEventListener('pointercancel', ende, true);
      inhalt.addEventListener('dragstart', function (e) { if (e.target.closest('.swiper-zoom-container')) e.preventDefault(); });
    }
    function mitte(f) {
      if (!st.img) st.img = aktivesBild(modal);
      if (!st.img) return;
      var r = st.img.parentElement.getBoundingClientRect();
      zoomUm(f, r.left + r.width / 2, r.top + r.height / 2);
    }
  }
  function deaktivieren(modal) {
    if (st.img) { st.img.style.transform = ''; st.img.style.cursor = ''; }
    st.s = 1; st.x = 0; st.y = 0; st.img = null; st.ziehen = null; st.swiper = null;
    modal.classList.remove('bs24-gezoomt');
  }
})();
